import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47144ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-hook" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Let's check out the lifecycle of this hur' child.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Open the console and reload the page to see the timing of different hooks", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { key: 0 }

import HookChild from "@/components/LifecycleHooksChild.vue";
import {onRenderTracked, onRenderTriggered, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isShowing = ref(false)

const toggleDisplayChild = () => {
  isShowing.value = !isShowing.value;
}

onRenderTracked( ({ key, target, type }) => {
  console.log('[MAIN COMPONENT] renderTracked: ' + JSON.stringify({ key, target, type }))
});

onRenderTriggered(({ key, target, type }) => {
  console.log('[MAIN COMPONENT] renderTriggered: ' + JSON.stringify({ key, target, type }))
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", { onClick: toggleDisplayChild }, [
      (isShowing.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Hide child"))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "Show child"))
    ]),
    _hoisted_6,
    (isShowing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(HookChild)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})